// src/PrivacyPolicy.js
import React from "react";

function PrivacyPolicy() {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Privacy Policy</h1>
      <p>
        Thank you for using "Who Pays? – Bill Games" (the "App"). Your privacy
        is important to us. This Privacy Policy explains how we handle your
        information when you use the App.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We do not collect any personal information. The App does not request,
        store, or share any user data.
      </p>

      <h2>2. Usage of the App</h2>
      <p>
        The App provides fun and social game modes for group decision-making.
        All actions and inputs stay local to your device. We do not track,
        upload, or analyze any user behavior or content.
      </p>

      <h2>3. Data Storage and Sharing</h2>
      <p>
        All information (like player names or game settings) remains on your
        device only during gameplay. Nothing is stored long-term or shared with
        any third party.
      </p>

      <h2>4. Security</h2>
      <p>
        While the App does not collect personal data, we still aim to maintain a
        secure and safe experience. No data leaves your device.
      </p>

      <h2>5. Ads and Monetization</h2>
      <p>
        The App may display third-party advertisements. These ad networks may
        collect data according to their own privacy policies. We recommend
        reviewing their terms if you interact with any ads.
      </p>

      <h2>6. Free and Easy to Use</h2>
      <p>
        The App is completely free to use and designed to offer entertainment
        without collecting any information from you.
      </p>

      <h2>7. Changes to This Privacy Policy</h2>
      <p>
        We may occasionally update this Privacy Policy. Changes will be posted
        here with an updated effective date. Continued use of the App after
        changes constitutes agreement to the revised policy.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or the App, feel
        free to reach out:
      </p>
      <p>
        Email:{" "}
        <a href="mailto:mega.mobile2267@gmail.com">mega.mobile2267@gmail.com</a>
      </p>

      <h2>9. Consent</h2>
      <p>By using the App, you consent to this Privacy Policy.</p>
    </div>
  );
}

export default PrivacyPolicy;
